import { Dropdown, Button } from "antd";
import { ChevronDown, RefreshCw } from "lucide-react";
import {
  syncGhlPipelineMetrics,
  syncGhlContacts,
  syncGhlOpportunities,
  syncGhlAppointments,
} from "services/ghl-integration.service";

const SYNC_OPTIONS = [
  {
    key: "pipeline",
    label: "Sync Pipeline",
    sync: (api) => syncGhlPipelineMetrics(api, { full: false }),
  },
  {
    key: "pipeline-full",
    label: "Full Historical Pipeline Sync",
    sync: (api) => syncGhlPipelineMetrics(api, { full: true }),
  },
  {
    key: "contacts",
    label: "Sync Contacts",
    sync: (api) => syncGhlContacts(api, { full: false }),
  },
  {
    key: "opportunities",
    label: "Sync Opportunities",
    sync: (api) => syncGhlOpportunities(api, { full: false }),
  },
  {
    key: "appointments",
    label: "Sync Appointments",
    sync: (api) => syncGhlAppointments(api, { full: false }),
  },
];

export default function GhlSyncDropdown({ api, onComplete, isSyncing, setIsSyncing, setSyncError }) {
  const handleSelect = async ({ key }) => {
    const option = SYNC_OPTIONS.find((item) => item.key === key);
    if (!option) return;

    setIsSyncing(true);
    setSyncError(null);
    try {
      await option.sync(api);
      await onComplete?.();
    } catch {
      setSyncError("GHL sync failed. Check GHL configuration.");
    } finally {
      setIsSyncing(false);
    }
  };

  const items = SYNC_OPTIONS.map((option) => ({
    key: option.key,
    label: option.label,
  }));

  return (
    <Dropdown
      menu={{ items, onClick: handleSelect }}
      trigger={["click"]}
      disabled={isSyncing}
    >
      <Button className="inline-flex items-center gap-2">
        <RefreshCw className={`h-4 w-4 ${isSyncing ? "animate-spin" : ""}`} />
        GHL Sync
        <ChevronDown className="h-4 w-4" />
      </Button>
    </Dropdown>
  );
}
